import React from "react";
import CareRichTextEditor from "./CareRichTextEditor";

const richTextFields = [
  ["diagnosis", "Diagnosis", 90],
  ["allergies", "Allergies", 90],
  ["diet", "Diet", 90],
  ["medicationNotes", "Current medication notes", 110],
  ["careNeeded", "Care needed", 110],
  ["behaviorSafetyNotes", "Behavior and safety notes", 110],
];

export default function InitialCareSnapshotForm({
  values = {},
  questions = [],
  compact = false,
  onChange,
  onAddQuestion,
  onUpdateQuestion,
  onRemoveQuestion,
}) {
  return (
    <div className={`initial-care-snapshot-grid${compact ? " is-compact" : ""}`}>
      <div className="initial-care-snapshot-main">
        {richTextFields.map(([name, label, height]) => (
          <div className="resident-form-field full-span" key={name}>
            <CareRichTextEditor
              height={compact ? Math.max(68, height - 30) : height}
              label={label}
              onChange={(value) => onChange?.(name, value)}
              value={values[name] || ""}
            />
          </div>
        ))}
      </div>
      <aside className="initial-care-custom-questions">
        <div className="resident-contact-toolbar">
          <span>
            <strong>Custom Questions</strong>
            <small>Add extra intake questions that are specific to this resident.</small>
          </span>
          <button className="btn primary" type="button" onClick={onAddQuestion}>
            <i className="ti ti-plus" /> Add Question
          </button>
        </div>
        {questions.length ? (
          <div className="care-custom-question-list">
            {questions.map((question, index) => (
              <article className="care-custom-question-card" key={question.id}>
                <div className="resident-other-insurance-title">
                  <strong>Question {index + 1}</strong>
                  <button aria-label="Remove question" type="button" onClick={() => onRemoveQuestion?.(question.id)}>
                    <i className="ti ti-trash" />
                  </button>
                </div>
                <label className="resident-form-field">
                  <span>Question</span>
                  <input value={question.question || ""} onChange={(event) => onUpdateQuestion?.(question.id, "question", event.target.value)} />
                </label>
                <label className="resident-form-field">
                  <span>Response</span>
                  <textarea rows={compact ? 2 : 3} value={question.response || ""} onChange={(event) => onUpdateQuestion?.(question.id, "response", event.target.value)} />
                </label>
              </article>
            ))}
          </div>
        ) : (
          <div className="resident-inline-empty">No custom questions added yet.</div>
        )}
      </aside>
    </div>
  );
}
